import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import {
    Input,
    Select,
    DatePickerField
} from '../../../../../../_metronic/_partials/controls';
import { role } from '../UserUIHelpers'
import { toastOption } from "../../../../../../_metronic/_helpers";
import { toast } from 'react-toastify'
import { shallowEqual, useSelector } from "react-redux";
import { getBranchAll } from '../../../_redux/branchs/branchCrud'
import TextField from '@material-ui/core/TextField';
import Selects from 'react-select';
import { getAccessRoleAll } from '../../../_redux/access-role/accessRoleCrud';
import { BlockOrg, RoleChecker, RoleCheckerNoRedux } from '../../../../../RoleChecker';


export function UserEditForm({ saveUser, actionsLoading, user, onHide }) {
    const { access } = useSelector(
        (state) => ({ access: state.auth.user.access_role.access }),
        shallowEqual,
    );
    // console.log(user);
    const [branch, setBranch] = useState([])
    const [channel, setChannel] = useState([])
    const [defaultChannelValue, setDefaultChannelValue] = useState([])
    const [accessRole, setAccessRole] = useState([])

    const { userAuth } = useSelector(
        (state) => ({ userAuth: state.auth.user }),
        shallowEqual,
    );
    // Validation schema
    let UserEditSchema;
    if (user.uuid === undefined) {
        UserEditSchema = Yup.object().shape({
            name: Yup.string()
                .min(3, 'Minimum 3 symbols')
                .max(50, 'Maximum 50 symbols')
                .required('Nama wajib di isi'),
            email: Yup.string().email()
                .required('Email wajib di isi'),
            // channel_uuid: Yup.string().required('Channel Wajib diisi'),
            role: Yup.string()
                .required('Role wajib di isi'),
            password: Yup.string().required('Required Password').min(6, 'Minimal 6 karakter'),
            is_active: Yup.string()
                .required('Status Aktif wajib di isi'),
            // hp: Yup.string()
            //     .required('Nomor Handphone Wajib Diisi !'),
        });
    } else {
        UserEditSchema = Yup.object().shape({
            name: Yup.string()
                .min(3, 'Minimum 3 symbols')
                .max(50, 'Maximum 50 symbols')
                .required('Nama wajib di isi'),
            email: Yup.string().email()
                .required('Email wajib di isi'),
            // channel_uuid: Yup.string().required('Channel Wajib diisi'),
            role: Yup.string()
                .required('Role wajib di isi'),
            change_pass: Yup.bool(),
            password: Yup.string().when('change_pass', {
                is: true,
                then: Yup.string().required('Membutuhkan Password').min(6, 'Minimal 6 karakter'),
                otherwise: Yup.string(),
            }),
            is_active: Yup.string()
                .required('Status Aktif wajib di isi'),
        });
    }

    const [checked, setChecked] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);
    let userEdited = { ...user }
    const disable_roles = ["CustomerCare", "AdminCabang", "FundCollCheck", "KepalaCabang"]

    const [roleValue, setRoleValue] = useState("")
    const [userActiveUntil, setUserActiveUntil] = useState(null)

    const handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        setChecked(value);
        setIsDisabled(!value);
    };

    useEffect(() => {
        const fetchBranch = () => {
            getBranchAll().then(response => {
                let filterCounter = response.data.data.filter(item => {
                    let findCounter = item.channel.find(val => val.type === 'COUNTER')
                    if (findCounter) return item
                })
                setBranch(filterCounter)
            }).catch(() => {
                setBranch([])
            })
        }
        fetchBranch()

        const fetchAccessRole = () => {
            getAccessRoleAll().then(response => {
                setAccessRole(response.data.data)
            }).catch(() => {
                setAccessRole([])
            })
        }
        fetchAccessRole()
    }, [])

    // console.log(accessRole);

    useEffect(() => {
        user.uuid === undefined ? setIsDisabled(false) : setIsDisabled(true);

        if (user.uuid && branch.length !== 0) {
            let obj = branch.find(object => object.uuid === user.channel.branch_uuid);
            let obj2 = obj.channel.filter((val) => val.type === 'COUNTER' || val.type === "ECHANNEL")
            obj2 = obj2.map((item) => {
                return { value: item.uuid, label: `${item.bank ? item.bank.name : item.type} - ${item.name}` }
            })
            setChannel(obj2);
        }
        if (user.name === '') {
            let obj = branch.find(object => object.uuid === userAuth.channel.branch_uuid);
            if (obj) {
                let obj2 = obj.channel.filter((val) => val.type === 'COUNTER' || val.type === "ECHANNEL")
                obj2 = obj2.map((item) => {
                    return { value: item.uuid, label: `${item.bank ? item.bank.name : item.type} - ${item.name}` }
                })
                setChannel(obj2);
            }
        }
        setUserActiveUntil(user.active_until)


        // userEd


        // console.log();


    }, [user, branch]);

    useEffect(() => {
        if (channel.length > 0) {
            let defaultValue = channel.find((item) => {
                if (user.channel_uuid === item.value) {
                    return item
                }
            })
            setDefaultChannelValue(defaultValue)

        }

    }, [channel])

    const addChannel = (value, setFieldValue) => {
        if (value === '') {
            setChannel([]);
        } else {
            let obj = branch.find(object => object.uuid === value)
            let obj2 = obj.channel.filter((val) => val.type === 'COUNTER' || val.type === "ECHANNEL")
            obj2 = obj2.map((item) => {
                return { value: item.uuid, label: `${item.bank ? item.bank.name : item.type} - ${item.name}` }
            })
            setChannel(obj2);
            if (disable_roles.includes(roleValue)) {
                setFieldValue("channel_uuid", obj2[0].value)
            }
        }
    }


    // console.log(defaultChannelValue);

    // console.log(userActiveUntil);
    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={user}
                validationSchema={UserEditSchema}
                onSubmit={(values) => {
                    if (values.channel_uuid) {
                        saveUser(values)
                        // console.log(values);
                    } else {
                        toast.error('harap pilih channel', toastOption)
                    }
                    // console.log(values);
                }
                }
            >
                {({ handleSubmit, values, setFieldValue, handleChange }) => (
                    <>
                        <Modal.Body className="overlay overlay-block cursor-default">
                            {actionsLoading && (
                                <div className="overlay-layer bg-transparent">
                                    <div className="spinner spinner-lg spinner-success" />
                                </div>
                            )}
                            <Form className="form form-label-right">
                                <div className="form-group row">
                                    <div className="col-lg-12">
                                        <Field
                                            name="name"
                                            component={Input}
                                            placeholder="Text"
                                            label="Name"
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-lg-12">
                                        <Field
                                            name="hp"
                                            component={Input}
                                            placeholder="08xxx"
                                            label="Nomor Handphone"
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-lg-12">
                                        <Field
                                            name="email"
                                            component={Input}
                                            placeholder="Email"
                                            label="Email"
                                            type="email"
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-lg-12">
                                        <Select
                                            name="is_active"
                                            label="Status Aktif"
                                            // onChange={(e) => {setFieldValue("role", e.target.value)}}
                                            onChange={(e) => {
                                                // changeRole(e)
                                                setFieldValue("is_active", e.target.value)
                                            }}
                                        >
                                            <option value="">-PILIH-</option>
                                            <option value={true}>Ya</option>
                                            <option value={false}>Tidak</option>
                                        </Select>
                                        <ErrorMessage name='is_active'
                                            render={msg => <div style={{ color: 'red' }}>{msg}</div>} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-lg-12">
                                        <Field
                                            name="active_until"
                                            component={TextField}
                                            label="Aktif Sampai Dengan (Kosongkan Jika Ingin Selamanya)"
                                            className="form-control"
                                            // defaultValue={user.active_until ? user.active_until : null}
                                            value={userActiveUntil}
                                            onChange={(e) => {
                                                setFieldValue('active_until', e.target.value)
                                                setUserActiveUntil(e.target.value)
                                                console.log(e.target.value);
                                            }}
                                            type="date"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {/* <TextField
                                            name="active_until"
                                            type="date"
                                            label="Aktif Sampai Dengan (Kosongkan Jika Ingin Selamanya)"
                                            className="form-control"
                                            onChange={(e) => {
                                                setFieldValue('active_until', e.target.value)
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        /> */}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-lg-12">
                                        <Select
                                            name="role"
                                            label="Role"
                                            // onChange={(e) => {setFieldValue("role", e.target.value)}}
                                            onChange={(e) => {
                                                // changeRole(e)
                                                setFieldValue("role", e.target.value)
                                                setRoleValue(e.target.value)
                                                setFieldValue('access_role_uuid', accessRole.find(item => item.name === e.target.value).uuid)
                                            }}
                                        >
                                            <option value="">-PILIH-</option>
                                            {accessRole.map(row =>
                                                <option key={row.uuid} value={row.name}>{row.name}</option>
                                            )}
                                        </Select>
                                        <ErrorMessage name='role'
                                            render={msg => <div style={{ color: 'red' }}>{msg}</div>} />
                                    </div>
                                </div>

                                {/* {RoleCheckerNoRedux('Edit Cabang', 'user', access) && (
                                    // userAuth.role === 'SuperAdmin' && (
                                    <div className="form-group row">
                                        <div className="col-lg-12">
                                            <Select
                                                name="channel.branch_uuid"
                                                label="Branch"
                                                onChange={(e) => {
                                                    addChannel(e.target.value, setFieldValue)
                                                    setFieldValue('channel.branch_uuid', e.target.value)

                                                }}
                                            >
                                                <option value="">-PILIH-</option>
                                                {branch.map(row =>
                                                    <option key={row.uuid} value={row.uuid}>{row.name}</option>
                                                )}
                                            </Select>
                                        </div>
                                    </div>
                                )} */}


                                {RoleCheckerNoRedux('Edit Channel', 'user', access) &&
                                    // !disable_roles.includes(roleValue) &&
                                    <div className="form-group row">
                                        <div className="col-lg-12">
                                            {/* <Select
                                                name="channel_uuid"
                                                label="Channel"
                                            >
                                                <option value="">-PILIH-</option>
                                                {channel.map(row =>
                                                    <option key={row.uuid} value={row.uuid}>{row.name}</option>
                                                )}
                                            </Select> */}

                                            <Field
                                                label="Channel"
                                                name="channel_uuid"

                                                component={Selects}
                                                id='channel'
                                                onChange={(e) => {
                                                    if (!e) {
                                                        setFieldValue('channel_uuid', "")
                                                    } else {
                                                        setFieldValue('channel_uuid', e.value)
                                                    }
                                                    setDefaultChannelValue(e)
                                                }}

                                                // defaultValue={channel.find((item) => user.channel_uuid === item.value)}
                                                // value={channel.find((item) => user.channel_uuid === item.value)}
                                                value={defaultChannelValue}
                                                options={channel}
                                                isClearable={true}
                                            />
                                            <ErrorMessage name='channel_uuid'
                                                render={msg => <div style={{ color: 'red' }}>{msg}</div>} />


                                            {/* <label htmlFor="channel">Select Channel</label>
                                            <Selects
                                                id='channel'
                                                onInputChange={(e) => {
                                                    // onInputDonatur2(e)
                                                }}
                                                onChange={(e) => {
                                                    // setSelectedDonatur2(e)
                                                }}
                                                options={channel}
                                                isClearable={true} />
                                            <label htmlFor="channel">Harap Pilih <b>Channel</b></label> */}


                                        </div>
                                    </div>
                                }


                                <div className="form-group row">
                                    <div className="col-lg-12">
                                        {user.uuid && (
                                            <label>
                                                <Field
                                                    name="change_pass"
                                                    type="checkbox"
                                                    checked={checked}
                                                    onChange={(e) => {
                                                        handleInputChange(e);
                                                        setFieldValue('change_pass', e.target.checked);
                                                        setFieldValue('password', '');
                                                    }}
                                                /> Change&nbsp;
                                            </label>
                                        )}

                                        <Field
                                            name="password"
                                            component={Input}
                                            placeholder="Password"
                                            label="Password"
                                            type="Password"
                                            disabled={isDisabled}
                                            value={undefined}
                                        />

                                    </div>
                                </div>
                            </Form>

                        </Modal.Body>
                        <Modal.Footer>
                        {BlockOrg() && (
                            <>
                            <button
                                type="button"
                                onClick={onHide}
                                className="btn btn-light btn-elevate"
                            >
                                Cancel
                            </button>
                            <> </>
                            <button
                                type="submit"
                                onClick={() => handleSubmit()}
                                className="btn btn-primary btn-elevate"
                            >
                                Save
                            </button>
                            </>
                        )}
                        </Modal.Footer>
                    </>
                )}
            </Formik>
        </>
    );
}
